/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Error_Password_Too_ShortInputs */

const es_co2_error_password_too_short = /** @type {(inputs: Error_Password_Too_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La contraseña debe tener al menos ${i?.count} caracteres.`)
};

/**

* @param {Error_Password_Too_ShortInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_password_too_short = /** @type {((inputs: Error_Password_Too_ShortInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_Too_ShortInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_password_too_short(inputs)
});